import { action, makeAutoObservable } from "mobx";

export class SchemeStore {
  schemeEligibiiltyRequest = {
    gender: "",
    isOrphan: true,
    age: 14,
    beneficiaryState: "",
    residence: "",
    caste: "",
    disabled: false,
    disabledPercentage: "",
    minority: false,
    bpl: false,
    hardship: true,
    familyIncome: "",
    parentIncome: "",
    isStudent: false,
    employmentStatus: "",
    governmentEmployee: false,
  };
  schemeSearchQuery = "";
  schemeFilterRequest = {
    query: "",
    offset: 0,
    count: 20,
    fields: [],
    schemeCategory: [],
    beneficiaryState: [],
    level: [],
    benefitType: [],
    dbtScheme: [],
    tags: [],
    schemeType: [],
    applicationMode: [],
    gender: [],
    caste: [],
    disabled: null,
    minority: null,
    student: null,
    orphan: null,
    bpl: null,
  };

  schemeFilterOption = {
    facets: {
      beneficiaryState: {},
      schemeCategory: {},
      schemeType: {},
      level: {},
      benefitTypes: {},
      dbtScheme: {},
      tags: {},
      applicationMode: {},
    },
    total_schemes: "",
    schemes: [],
  };

  constructor(rootStore: any) {
    makeAutoObservable(this);
  }

  setSearchQuery(value) {
    this.schemeSearchQuery = value;
    console.log(this.schemeSearchQuery);
  }

  setschemeFilterOption(value) {
    this.schemeFilterOption = value;
  }
  setschemeFilterRequest(value) {
    this.schemeFilterRequest = value;
  }

  setSchemeEligibitityRequest(value) {
    this.schemeEligibiiltyRequest = value;
  }
}
